//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

interface Props extends React.ComponentPropsWithoutRef<'td'> {
  children: React.ReactNode;
}

/**
 * This component exists for the purpose of standardizing table data cells `<td>`
 *
 * @param children The contents of the table data cell. This will typically consist of
 * stats formatted for use in `TableDataPrimaryText` and `TableDataSecondaryText` components.
 *
 * @example
 * <TableDataCell>
 *   <TableDataPrimaryText>Some Stat</TableDataPrimaryText>
 *   <TableDataSecondaryText>Some Other Stat</TableDataSecondaryText>
 * </TableDataCell>
 */
export const TableDataCell = (
  {
    children,
    className,
    ...cellProps
  }: Props
) => {
  return (
    <StyledTD className={className} {...cellProps}>
      {children}
    </StyledTD>
  );
};

const StyledTD = styled.td(
  ({ theme }) => `
    padding: ${theme.spacings[3]} ${theme.spacings[1]};
    
    &:first-child {
      padding: ${theme.spacings[3]} ${theme.spacings[1]} ${theme.spacings[3]} ${theme.spacings[3]};
    }
    &:last-child {
      padding: ${theme.spacings[3]} ${theme.spacings[4]} ${theme.spacings[3]} ${theme.spacings[1]};      
    }
  `,
);
